import {Button, Col, Form, Row, Space, Spin, message} from "antd";
import {InputFields} from "components/common";
import React, {useEffect, useState} from "react";
import {dataFields} from "./ModalAction.config";
import {employeeService} from "api";
import Notification from "../../../../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import {dataFields as inputFieldsInit} from "./ModalAction.config";
import { RangePickerProps } from "antd/es/date-picker";
const ModalAction = props => {
  const {data, closeModal, type, getListStore} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("ngayApDungDen");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("ngayApDungTu");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "ngayApDungTu").disabledDate = disabledDateStart;
    inputFieldsInit.find(e => e.name == "ngayApDungDen").disabledDate = disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  const add = async () => {
    const data = form.getFieldsValue();
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),

      };
      const res = await employeeService.createNghiPhep(data);
      setLoading(false);
      closeModal();
      Notification("success", "Đã thêm mới ngày nghỉ phép tháng");
      await getListStore();
      form.resetFields();
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400){
        Notification("error", error.response.data);
      }else {
        Notification("error", "Đã có lỗi khi thêm mới ngày nghỉ phép tháng");
      }


    }
  };
  const update = async () => {

    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        id:data.id,

      };
      const res = await employeeService.editNghiPhep(params);
      setLoading(false);
      closeModal();
      await getListStore();
      Notification("success", "Đã cập nhật ngày nghỉ phép tháng");

    } catch (error) {
      setLoading(false);
      if (error.response.status === 400){
        Notification("error", error.response.data);
      }else {
        Notification("error", "Đã có lỗi khi sửa thông tin ngày nghỉ phép tháng");
      }

    }
  };
  useEffect(() => {

    form.setFieldsValue({
      ...data,

      ngayApDungTu: data?.ngayApDungTu
          ? dayjs(data.ngayApDungTu)
          : null,
      ngayApDungDen: data?.ngayApDungDen
          ? dayjs(data.ngayApDungDen)
          : null,


    });


  }, [data]);
  const onFinish = values => {
    if (type == "Thêm") {
      add();
    } else {
      update();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 20 }}>
              <Col>
                <Space>
                  <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};

export default ModalAction;
